import React, { useRef, useEffect, useState } from "react";
import Avatar from "react-avatar";
import SearchIcon from "../../../Assets/Images/SearchIcon.png";
// import uploadIco from "../../../Assets/Images/uploadIco.png";
import submitIco from "../../../Assets/Images/SubmitIco.png";
import logo from "../../../Assets/Images/Logo.png";

import "./AdminChat.css";
import {
  getChatUserList,
  getUserChat,
  updateUnreadMessage,
  sendingMessage,
} from "../../../Services/ChatApi";
import InfiniteScroll from "react-infinite-scroll-component";
import { ColorRing } from "react-loader-spinner";
// import echo from "../../../Helpers/echo";
import pusher from "../../../Helpers/pusher";
import { FaPaperclip } from "react-icons/fa";
// import { FaXmark } from "react-icons/fa6";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFile,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

export default function AdminChat() {
  const chatContainerRef = useRef(null);

  const [chatList, setChatList] = useState([]);
  const [userChat, setUserChat] = useState([]);

  const [sendMessage, setSendMessage] = useState("");

  const [senderDetail, setSenderDetail] = useState("");
  const [timeoutId, setTimeoutId] = useState(-1);

  const [searchText, setSearchText] = useState("");
  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [totalChatPage, setTotalChatPage] = useState(1);
  const [currentChatPage, setCurrentChatPage] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isSendingMessage, setisSendingMessage] = useState(false);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const fileIcons = {
    pdf: faFilePdf,
    doc: faFileWord,
    docx: faFileWord,
    xls: faFileExcel,
    xlsx: faFileExcel,
    jpeg: faFileImage,
    jpg: faFileImage,
    png: faFileImage,
    gif: faFileImage,
    default: faFile,
  };

  const getFileIcon = (fileType) => {
    return fileIcons[fileType] || fileIcons["default"];
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(file);
      const fileExtension = file.name.split(".").pop();
      setSelectedFile({
        name: file.name,
        type: fileExtension,
        url: URL.createObjectURL(file),
      });
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setUploadedFile(null);
  };

  const fetchChatList = async (replace = false) => {
    let response = await getChatUserList(
      searchText,
      replace ? 1 : currentPage + 1
    );
    setCurrentPage((pg) => (replace ? 1 : pg + 1));
    setTotalPage(response?.data?.data?.totalPageCount || 1);
    let list = response?.data?.data?.users;
    if (!senderDetail && (chatList?.length || list?.length)) {
      await handleChat(chatList?.[0] || list?.[0]);
      if (list?.[0]) {
        list[0].unread_message_count = 0;
      }
    }
    if (list?.length || list?.length >= 0) {
      if (!replace) setChatList((prevList) => [...prevList, ...list]);
      else setChatList(list);
    }
    // console.log(chatList.length)
    // console.log(totalPage);
    // console.log(currentPage);
  };

  // useEffect(() => {
  //   if (senderDetail) {
  //     echo.leaveChannel("chat");
  //     echo.channel("chat").listen("MessageSent", (e) => {
  //       if (e?.messages?.sender_id === senderDetail.id)
  //         setUserChat((prevMessages) => [e.messages, ...prevMessages]);
  //       if (chatContainerRef.current) {
  //         chatContainerRef.current.scrollTop =
  //           chatContainerRef.current.scrollHeight;
  //       }
  //     });

  //     return () => {
  //       echo.leaveChannel("chat");
  //     };
  //   }
  // }, [senderDetail]);

  useEffect(() => {
    // Request permission on page load
    // if (Notification.permission !== 'granted') {
    //   Notification.requestPermission();
    // }

    if (senderDetail) {
      const channel = pusher.subscribe("chat");
      channel.bind("App\\Events\\MessageSent", async function (data) {
        if (data.length) {
          var msg = data[0];
          let adminDetails = JSON.parse(localStorage.getItem("loginDetails"));
          let adminId = adminDetails.adminId ? adminDetails.adminId : adminDetails.id;
          // fetchChatList(true);
          // if (msg.sender_id === senderDetail.id || adminDetails.adminId) {
          if (msg.sender_id === senderDetail.id) {
            if(adminId === msg.receiver_id){
              // updateUnreadMessage(senderDetail.id);
              setUserChat((prevMessages) => [msg, ...prevMessages]);
              if (chatContainerRef.current) {
                chatContainerRef.current.scrollTop =
                  chatContainerRef.current.scrollHeight;
              }
            }
          }
          fetchChatList(true);

          // send notificaton
          if (adminId == msg.receiver_id || adminId == msg.receiver_id) {
            if ("safari" in window && "pushNotification" in window.safari) {
            } else if ("Notification" in window) {
              if (window.Notification.permission === "granted") {
                navigator.serviceWorker.ready.then((registration) => {
                  registration.showNotification(
                    `123MyVPN - ${msg.sender_name}`,
                    {
                      body: msg.message,
                      icon: logo,
                    }
                  );
                });
              } else if (window.Notification.permission !== "denied") {
                window.Notification.requestPermission().then(function (
                  permission
                ) {
                  if (permission === "granted") {
                    navigator.serviceWorker.ready.then((registration) => {
                      registration.showNotification(
                        `123MyVPN - ${msg.sender_name}`,
                        {
                          body: msg.message,
                          icon: logo,
                        }
                      );
                    });
                  }
                });
              }
            }
          }
        }
      });

      return () => {
        pusher.unsubscribe("chat");
      };
    }
  }, [senderDetail]);

  useEffect(() => {
    setCurrentPage(0);
    fetchChatList(true);
  }, [searchText]);

  const handleChat = async (data) => {
    setIsLoading(true);
    setCurrentChatPage(0);
    setTotalChatPage(1);
    await getChat(data, true);
    setIsLoading(false);
  };

  const getChat = async (
    data,
    replace = false,
    currentPage = currentChatPage
  ) => {
    let updateresponse = await updateUnreadMessage(data?.id);
    let response = await getUserChat(data?.id, replace ? 1 : currentPage + 1);
    setCurrentChatPage(replace ? 1 : currentPage + 1);
    setSenderDetail(data);
    setChatList((user) =>
      user.map((ele) => {
        if (ele.id == data.id) ele.unread_message_count = 0;
        return ele;
      })
    );
    setTotalChatPage(response?.data?.data?.totalPageCount);
    if (response?.data?.data?.messages?.length) {
      if (!replace)
        setUserChat((prevMsg) =>
          [...prevMsg, ...response?.data?.data?.messages].filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.id === value.id)
          )
        );
      else setUserChat(response?.data?.data?.messages);
    } else {
      setUserChat([]);
    }
  };

  const handleMessage = (e) => {
    setSendMessage(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      send();
    }
  };

  // const send = async (ev) => {
  const send = async () => {
    // ev.preventDefault();
    setSendMessage("");
    setisSendingMessage(true);
    // await sendingMessage(senderDetail?.id, sendMessage);
    const formData = new FormData();
    if (uploadedFile) formData.append("file", uploadedFile);
    formData.append("receiver_id", senderDetail?.id);
    formData.append("message", sendMessage);

    await sendingMessage(formData);
    setCurrentChatPage(0);
    await getChat(senderDetail, true, 0);
    setisSendingMessage(false);
    handleRemoveFile();
  };

  const onSearchChange = (ev) => {
    if (timeoutId) clearInterval(timeoutId);
    setTimeoutId(
      setTimeout(() => {
        setSearchText(ev.target.value);
      }, 500)
    );
  };

  // Scroll to the bottom of the chat container whenever userChat is updated
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [senderDetail]);

  return (
    <section className="AdminSupport px-3">
      <div className="AdminSupportTable">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-block w-100 headingAdmin py-3">
            <h2 className="">Chat</h2>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4">
          <div className="chatMainContainer">
            <div className="chat-recipient">
              <div className="searchBoxRec">
                <div className="input-group">
                  <span className="input-group-text border-end-0 rounded-start-5 bg-white">
                    <img src={SearchIcon} alt="Search" className="img-fluid" />
                  </span>
                  <input
                    type="text"
                    className="form-control searchTextBox rounded-end-5 py-3 border-start-0"
                    placeholder="Search Here..."
                    onChange={onSearchChange}
                  />
                </div>
              </div>
            </div>
            <InfiniteScroll
              className="chatContainer"
              dataLength={chatList.length}
              hasMore={currentPage < totalPage && chatList.length !== 0}
              next={fetchChatList}
              height={470}
              loader={
                <div className="d-flex justify-content-center w-full">
                  <ColorRing
                    type="ThreeDots"
                    color="#00BFFF"
                    height={50}
                    width={50}
                  />
                </div>
              }
              endMessage={
                <p style={{ textAlign: "center", color: "gray" }}>
                  No more chats!
                </p>
              }
            >
              <div>
                {chatList?.map((user, index) => (
                  <div
                    className={`chatInnerContainer ${
                      senderDetail.id == user.id ? "active" : ""
                    }`}
                    key={index}
                  >
                    <div
                      className="chatUser"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleChat(user)}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex">
                          <Avatar name={user?.name} size="40" round={true} />
                          <div className="d-flex flex-column justify-content-center ps-2">
                            <div
                              className={`chat-message fs-6 ${
                                user?.unread_message_count &&
                                user?.unread_message_count > 0
                                  ? "unseen"
                                  : ""
                              }`}
                            >
                              {user?.name}
                            </div>
                            <small className="fs-6 fw-light text-start">
                              {user?.message}
                            </small>
                          </div>
                        </div>
                        <div>{user?.time}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </InfiniteScroll>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="messageMainContainer">
            <div className="messageInnerContainer">
              <div className="chatUser">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex">
                    <Avatar name={senderDetail?.name} size="40" round={true} />
                    <div className="d-flex flex-column justify-content-center ps-2">
                      <div className="fs-6 fw-medium">{senderDetail?.name}</div>
                    </div>
                  </div>
                </div>
              </div>
              {senderDetail && !isLoading ? (
                <div
                  className="messageContainer"
                  id="messageContainer"
                  ref={chatContainerRef}
                >
                  <InfiniteScroll
                    dataLength={userChat.length}
                    hasMore={
                      currentChatPage < totalChatPage && userChat.length !== 0
                    }
                    height={"calc(100vh - 486px)"}
                    style={{ display: "flex", flexDirection: "column-reverse" }}
                    next={() => getChat(senderDetail)}
                    loader={
                      <div className="d-flex justify-content-center w-full">
                        <ColorRing
                          type="ThreeDots"
                          color="#00BFFF"
                          height={50}
                          width={50}
                        />
                      </div>
                    }
                    inverse={true}
                    scrollableTarget={"messageContainer"}
                  >
                    {userChat?.map((data, index) => (
                      <div className="" key={index}>
                        {senderDetail?.name === data?.sender_name ? (
                          <div className="d-flex justify-content-start mb-4">
                            <div className="img_cont_msg">
                              <Avatar
                                name={data?.sender_name}
                                size="40"
                                round={true}
                              />
                            </div>
                            {data?.is_file == 1 && (
                              <div className="msg_cotainer">
                                <div
                                  className="file"
                                  style={{
                                    display: "flex",
                                    "align-items": "center",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={getFileIcon(data?.file_type)}
                                  />
                                  <a
                                    href={data?.file_url}
                                    target="_blank"
                                    style={{
                                      marginLeft: "5px",
                                      textDecoration: "none",
                                      color: "#16a34a",
                                    }}
                                    rel="noopener noreferrer"
                                  >
                                    {data?.file_name}
                                  </a>
                                  <a
                                    href={data.file_url}
                                    download={data.file_name}
                                    style={{
                                      marginLeft: "5px",
                                      textDecoration: "none",
                                      color: "#16a34a",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                      style={{
                                        marginLeft: "10px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </a>
                                </div>
                              </div>
                            )}

                            {data?.message != "" && data?.message != null && (
                              <div className="msg_cotainer">
                                {data?.message}
                              </div>
                            )}
                            <span className="msg_time">
                              {data?.updated_at &&
                                new Date(data.updated_at).toLocaleString(
                                  "en-US",
                                  {
                                    hour: "numeric",
                                    minute: "numeric",
                                    hour12: true,
                                  }
                                )}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex justify-content-end mb-4">
                            {data?.is_file == 1 && (
                              <div className="msg_cotainer_send">
                                <div
                                  className="file"
                                  style={{
                                    display: "flex",
                                    "align-items": "center",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={getFileIcon(data?.file_type)}
                                  />
                                  <a
                                    href={data?.file_url}
                                    target="_blank"
                                    style={{
                                      marginLeft: "5px",
                                      textDecoration: "none",
                                      color: "#f8f9fa",
                                    }}
                                    rel="noopener noreferrer"
                                  >
                                    {data?.file_name}
                                  </a>
                                  <a
                                    href={data.file_url}
                                    download={data.file_name}
                                    style={{
                                      marginLeft: "5px",
                                      textDecoration: "none",
                                      color: "#f8f9fa",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                      style={{
                                        marginLeft: "10px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </a>
                                </div>
                              </div>
                            )}
                            {data?.message != "" && data?.message != null && (
                              <div className="msg_cotainer_send">
                                {data?.message}
                              </div>
                            )}
                            <span className="msg_time_send">
                              {data?.updated_at &&
                                new Date(data.updated_at).toLocaleString(
                                  "en-US",
                                  {
                                    hour: "numeric",
                                    minute: "numeric",
                                    hour12: true,
                                  }
                                )}
                            </span>
                            {/* <div className="img_cont_msg">
                              <Avatar
                                name={data?.sender_name}
                                size="40"
                                round={true}
                              />
                            </div> */}
                          </div>
                        )}
                      </div>
                    ))}
                  </InfiniteScroll>
                </div>
              ) : (
                <div
                  className="messageContainer"
                  ref={chatContainerRef}
                  style={{ height: "calc(100vh - 456px)" }}
                ></div>
              )}
              <div className="messageSenderText">
                <div className="d-flex align-items-center">
                  <form
                    // onSubmit={send}
                    className="input-group position-relative"
                  >
                    {/* <input
                      type="file"
                      id="fileUpload"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <label htmlFor="fileUpload" className="pt-2">
                      <FaPaperclip
                        style={{
                          fontSize: "20px",
                          marginRight: "10px",
                          cursor: "pointer",
                        }}
                      />
                    </label>
                    {selectedFile && (
                      <div className="selected-file">
                        <FontAwesomeIcon icon={getFileIcon(selectedFile.type)} />
                        <a href={selectedFile.url} target="_blank" rel="noopener noreferrer">
                          {selectedFile.name}
                        </a>
                        <button onClick={handleRemoveFile}>Remove</button>
                      </div>
                    )} */}
                    <textarea
                      type="text"
                      value={sendMessage}
                      className="form-control chatTextBox"
                      placeholder="Type message"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      style={{ resize: "none" }}
                      rows={1}
                      onChange={handleMessage}
                      onKeyPress={handleKeyPress}
                      disabled={isSendingMessage}
                    />
                    <div className="input-group-prepend">
                      <button
                        className="input-group-text justify-content-center SubmitBg"
                        id="basic-addon1"
                        disabled={isSendingMessage}
                        onClick={send}
                      >
                        <img
                          src={submitIco}
                          alt="submitIco"
                          className="d-block m-auto"
                        />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
